
import React, { useEffect, useRef, useState } from "react";

// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col,
    Spinner,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
} from "reactstrap";
import { BASE_URL } from "../../utils/constants";
import Swal from "sweetalert2";
import axios from "axios";
import { useSelector } from "react-redux";
import PanelHeader from "components/PanelHeader/PanelHeader";
import { MDBDataTableV5 } from "mdbreact";
import { IconButton } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
// import EditIcon from "@mui/icons-material/Edit";

const MyBragSheetInput = (props) => {

    return (
        <Card className="p-3">
            <p>
                {props.headLine}
            </p>
            <hr />
            <CardBody
                className="bg-light"
            >
                <textarea
                    style={{
                        width: "100%",
                        height: "150px",
                        padding: "12px 20px",
                        boxSizing: "border-box",
                        border: "2px solid #ccc",
                        borderRadius: "4px",
                        // backgroundColor: "#f8f8f8",
                        fontSize: "16px",
                        resize: "none",
                    }}
                    type="text"
                    name={props.name}
                    value={props.data}
                    placeholder={`type here`}

                    onChange={(e) => {
                        // //console.log(e.target.value)
                        props.setData(e.target.value)
                    }}
                    // onBlur={(e) => {
                    //     //console.log(e.target.value)
                    //     props.setData(e.target.value)
                    // }}
                />
                {
                    // props.editable ?
                    //     <IconButton
                    //         color="primary"
                    //         onClick={() => {
                    //             const tmp = {}
                    //             props.data.columns.forEach(element => {
                    //                 // //console.log("element")
                    //                 // //console.log(element.field)
                    //                 tmp[element.field] = ""
                    //             });
                    //             tmp["action"] = (<IconButton
                    //                 color="primary"
                    //                 onClick={() => {
                    //                     //console.log("DeleteIcon")
                    //                 }}
                    //             >
                    //                 <DeleteIcon fontSize="large" />
                    //             </IconButton>);
                    //             // //console.log("tmp")
                    //             // //console.log(tmp)
                    //             props.data.rows.push(tmp)
                    //             props.setData(x => ({ ...x }))
                    //         }}
                    //     >
                    //         <AddCircleIcon fontSize="large" />
                    //     </IconButton>
                    //     : null
                }
            </CardBody>

            <div className="text-center d-flex">
                <button
                    className="btn btn-primary fw-bolder mx-auto w-25"
                    onClick={props.saveFunction}
                >
                    Save
                </button>
            </div>

        </Card>
    )
}

export default MyBragSheetInput